var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "l-bg-white roles" }, [
      _c(
        "form",
        {
          attrs: { autocomplete: "no" },
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.save($event)
            }
          }
        },
        [
          _c("div", { staticClass: "row mb-4" }, [
            _c(
              "div",
              { staticClass: "col pr-1" },
              [
                _c("div", { staticClass: "select-wrap" }, [
                  _c("label", [_vm._v("Role name")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.role.name,
                        expression: "role.name"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: {
                      type: "text",
                      placeholder: "name",
                      disabled: !_vm.$_can("carriers.roles.update")
                    },
                    domProps: { value: _vm.role.name },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.role, "name", $event.target.value)
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("error-field", {
                  attrs: { errors: _vm.errors, field: "name" }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "col px-1" }, [
              _c(
                "div",
                { staticClass: "select-wrap" },
                [
                  _c("label", { staticClass: "m-label" }, [
                    _vm._v("Department")
                  ]),
                  _vm._v(" "),
                  _c("simple-select", {
                    attrs: {
                      options: _vm.departments,
                      disabled: !_vm.$_can("carriers.roles.update"),
                      placeholder: "Select Department"
                    },
                    model: {
                      value: _vm.role.department_id,
                      callback: function($$v) {
                        _vm.$set(_vm.role, "department_id", $$v)
                      },
                      expression: "role.department_id"
                    }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col pl-1" },
              [
                _c(
                  "div",
                  { staticClass: "select-wrap" },
                  [
                    _c("label", [_vm._v("Carrier")]),
                    _vm._v(" "),
                    _c("simple-select", {
                      attrs: {
                        options: _vm.carriers,
                        disabled: !_vm.$_can("carriers.roles.update"),
                        placeholder: "Select Carrier"
                      },
                      model: {
                        value: _vm.role.carrier_id,
                        callback: function($$v) {
                          _vm.$set(_vm.role, "carrier_id", $$v)
                        },
                        expression: "role.carrier_id"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("error-field", {
                  attrs: { errors: _vm.errors, field: "carrier_id" }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _vm._m(1),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col" }, [
              _c("div", { staticClass: "row mb-3" }, [
                _c("div", { staticClass: "col" }, [
                  _c(
                    "div",
                    { staticClass: "mb-1 mr-4 nav nav-tabs nav-fill" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "nav-item nav-link pointer",
                          class: [
                            _vm.permissionsStep === "all" ? "active" : ""
                          ],
                          on: {
                            click: function($event) {
                              _vm.setPermissionsStep("all")
                            }
                          }
                        },
                        [_vm._v("\n                  All\n                ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "nav-item nav-link pointer",
                          class: [
                            _vm.permissionsStep === "carriers" ? "active" : ""
                          ],
                          on: {
                            click: function($event) {
                              _vm.setPermissionsStep("carriers")
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                  Carriers\n                "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "nav-item nav-link pointer",
                          class: [
                            _vm.permissionsStep === "companies" ? "active" : ""
                          ],
                          on: {
                            click: function($event) {
                              _vm.setPermissionsStep("companies")
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                  Companies\n                "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "nav-item nav-link pointer",
                          class: [
                            _vm.permissionsStep === "leads" ? "active" : ""
                          ],
                          on: {
                            click: function($event) {
                              _vm.setPermissionsStep("leads")
                            }
                          }
                        },
                        [_vm._v("\n                  Leads\n                ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "nav-item nav-link pointer",
                          class: [
                            _vm.permissionsStep === "jobs" ? "active" : ""
                          ],
                          on: {
                            click: function($event) {
                              _vm.setPermissionsStep("jobs")
                            }
                          }
                        },
                        [_vm._v("\n                  Jobs\n                ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "nav-item nav-link pointer",
                          class: [
                            _vm.permissionsStep === "claims" ? "active" : ""
                          ],
                          on: {
                            click: function($event) {
                              _vm.setPermissionsStep("claims")
                            }
                          }
                        },
                        [_vm._v("\n                  Claims\n                ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "nav-item nav-link pointer",
                          class: [
                            _vm.permissionsStep === "users" ? "active" : ""
                          ],
                          on: {
                            click: function($event) {
                              _vm.setPermissionsStep("users")
                            }
                          }
                        },
                        [_vm._v("\n                  Users\n                ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "nav-item nav-link pointer",
                          class: [
                            _vm.permissionsStep === "movers" ? "active" : ""
                          ],
                          on: {
                            click: function($event) {
                              _vm.setPermissionsStep("movers")
                            }
                          }
                        },
                        [_vm._v("\n                  Movers\n                ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "nav-item nav-link pointer",
                          class: [
                            _vm.permissionsStep === "trucks" ? "active" : ""
                          ],
                          on: {
                            click: function($event) {
                              _vm.setPermissionsStep("trucks")
                            }
                          }
                        },
                        [_vm._v("\n                  Trucks\n                ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "nav-item nav-link pointer",
                          class: [
                            _vm.permissionsStep === "transactions"
                              ? "active"
                              : ""
                          ],
                          on: {
                            click: function($event) {
                              _vm.setPermissionsStep("transactions")
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                  Transactions\n                "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "nav-item nav-link pointer",
                          class: [
                            _vm.permissionsStep === "customers" ? "active" : ""
                          ],
                          on: {
                            click: function($event) {
                              _vm.setPermissionsStep("customers")
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                  Customers\n                "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "nav-item nav-link pointer",
                          class: [
                            _vm.permissionsStep === "settings" ? "active" : ""
                          ],
                          on: {
                            click: function($event) {
                              _vm.setPermissionsStep("settings")
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                  Settings\n                "
                          )
                        ]
                      )
                    ]
                  )
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _vm.permissionsStep === "all"
            ? _c("section", [
                _c(
                  "div",
                  { staticClass: "row mb-2 user-role" },
                  _vm._l(_vm.companyPerm, function(permission, index) {
                    return _c(
                      "div",
                      { key: permission.id, staticClass: "col-3" },
                      [
                        _c("div", { staticClass: "check-field" }, [
                          _c(
                            "label",
                            {
                              class: [
                                {
                                  "check-open": _vm.permission_ids.find(
                                    function(el) {
                                      return el === permission.id
                                    }
                                  )
                                },
                                {
                                  disabled: !_vm.$_can("carriers.roles.update")
                                }
                              ],
                              attrs: { for: "permissions_id-" + permission.id }
                            },
                            [
                              _c("span", { staticClass: "checkmark" }),
                              _vm._v(
                                _vm._s(permission.description) +
                                  "\n                "
                              ),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.permission_ids,
                                    expression: "permission_ids"
                                  }
                                ],
                                key: index,
                                staticClass: "btn-check",
                                attrs: {
                                  type: "checkbox",
                                  id: "permissions_id-" + permission.id,
                                  disabled: !_vm.$_can("carriers.roles.update")
                                },
                                domProps: {
                                  value: permission.id,
                                  checked: Array.isArray(_vm.permission_ids)
                                    ? _vm._i(
                                        _vm.permission_ids,
                                        permission.id
                                      ) > -1
                                    : _vm.permission_ids
                                },
                                on: {
                                  change: function($event) {
                                    var $$a = _vm.permission_ids,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = permission.id,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.permission_ids = $$a.concat([
                                            $$v
                                          ]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.permission_ids = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.permission_ids = $$c
                                    }
                                  }
                                }
                              })
                            ]
                          )
                        ])
                      ]
                    )
                  })
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.permissionsStep === "carriers"
            ? _c("section", [
                _c(
                  "div",
                  { staticClass: "row mb-2 user-role" },
                  _vm._l(_vm.carrierPermissions, function(permission, index) {
                    return _c(
                      "div",
                      { key: permission.id, staticClass: "col-3" },
                      [
                        _c("div", { staticClass: "check-field" }, [
                          _c(
                            "label",
                            {
                              class: [
                                {
                                  "check-open": _vm.permission_ids.find(
                                    function(el) {
                                      return el === permission.id
                                    }
                                  )
                                },
                                {
                                  disabled: !_vm.$_can("carriers.roles.update")
                                }
                              ],
                              attrs: { for: "permissions_id-" + permission.id }
                            },
                            [
                              _c("span", { staticClass: "checkmark" }),
                              _vm._v(
                                _vm._s(permission.description) +
                                  "\n                "
                              ),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.permission_ids,
                                    expression: "permission_ids"
                                  }
                                ],
                                key: index,
                                staticClass: "btn-check",
                                attrs: {
                                  type: "checkbox",
                                  id: "permissions_id-" + permission.id,
                                  disabled: !_vm.$_can("carriers.roles.update")
                                },
                                domProps: {
                                  value: permission.id,
                                  checked: Array.isArray(_vm.permission_ids)
                                    ? _vm._i(
                                        _vm.permission_ids,
                                        permission.id
                                      ) > -1
                                    : _vm.permission_ids
                                },
                                on: {
                                  change: function($event) {
                                    var $$a = _vm.permission_ids,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = permission.id,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.permission_ids = $$a.concat([
                                            $$v
                                          ]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.permission_ids = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.permission_ids = $$c
                                    }
                                  }
                                }
                              })
                            ]
                          )
                        ])
                      ]
                    )
                  })
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.permissionsStep === "companies"
            ? _c("section", [
                _c(
                  "div",
                  { staticClass: "row mb-2 user-role" },
                  _vm._l(_vm.companyPermCompanies, function(permission, index) {
                    return _c(
                      "div",
                      { key: permission.id, staticClass: "col-3" },
                      [
                        _c("div", { staticClass: "check-field" }, [
                          _c(
                            "label",
                            {
                              class: [
                                {
                                  "check-open": _vm.permission_ids.find(
                                    function(el) {
                                      return el === permission.id
                                    }
                                  )
                                },
                                {
                                  disabled: !_vm.$_can("carriers.roles.update")
                                }
                              ],
                              attrs: { for: "permissions_id-" + permission.id }
                            },
                            [
                              _c("span", { staticClass: "checkmark" }),
                              _vm._v(
                                _vm._s(permission.description) +
                                  "\n                "
                              ),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.permission_ids,
                                    expression: "permission_ids"
                                  }
                                ],
                                key: index,
                                staticClass: "btn-check",
                                attrs: {
                                  type: "checkbox",
                                  id: "permissions_id-" + permission.id,
                                  disabled: !_vm.$_can("carriers.roles.update")
                                },
                                domProps: {
                                  value: permission.id,
                                  checked: Array.isArray(_vm.permission_ids)
                                    ? _vm._i(
                                        _vm.permission_ids,
                                        permission.id
                                      ) > -1
                                    : _vm.permission_ids
                                },
                                on: {
                                  change: function($event) {
                                    var $$a = _vm.permission_ids,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = permission.id,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.permission_ids = $$a.concat([
                                            $$v
                                          ]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.permission_ids = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.permission_ids = $$c
                                    }
                                  }
                                }
                              })
                            ]
                          )
                        ])
                      ]
                    )
                  })
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.permissionsStep === "leads"
            ? _c("section", [
                _c(
                  "div",
                  { staticClass: "row mb-2 user-role" },
                  _vm._l(_vm.companyPermLeads, function(permission, index) {
                    return _c(
                      "div",
                      { key: permission.id, staticClass: "col-3" },
                      [
                        _c("div", { staticClass: "check-field" }, [
                          _c(
                            "label",
                            {
                              class: [
                                {
                                  "check-open": _vm.permission_ids.find(
                                    function(el) {
                                      return el === permission.id
                                    }
                                  )
                                },
                                {
                                  disabled: !_vm.$_can("carriers.roles.update")
                                }
                              ],
                              attrs: { for: "permissions_id-" + permission.id }
                            },
                            [
                              _c("span", { staticClass: "checkmark" }),
                              _vm._v(
                                _vm._s(permission.description) +
                                  "\n                "
                              ),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.permission_ids,
                                    expression: "permission_ids"
                                  }
                                ],
                                key: index,
                                staticClass: "btn-check",
                                attrs: {
                                  type: "checkbox",
                                  id: "permissions_id-" + permission.id,
                                  disabled: !_vm.$_can("carriers.roles.update")
                                },
                                domProps: {
                                  value: permission.id,
                                  checked: Array.isArray(_vm.permission_ids)
                                    ? _vm._i(
                                        _vm.permission_ids,
                                        permission.id
                                      ) > -1
                                    : _vm.permission_ids
                                },
                                on: {
                                  change: function($event) {
                                    var $$a = _vm.permission_ids,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = permission.id,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.permission_ids = $$a.concat([
                                            $$v
                                          ]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.permission_ids = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.permission_ids = $$c
                                    }
                                  }
                                }
                              })
                            ]
                          )
                        ])
                      ]
                    )
                  })
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.permissionsStep === "jobs"
            ? _c("section", [
                _c(
                  "div",
                  { staticClass: "row mb-2 user-role" },
                  _vm._l(_vm.companyPermJobs, function(permission, index) {
                    return _c(
                      "div",
                      { key: permission.id, staticClass: "col-3" },
                      [
                        _c("div", { staticClass: "check-field" }, [
                          _c(
                            "label",
                            {
                              class: [
                                {
                                  "check-open": _vm.permission_ids.find(
                                    function(el) {
                                      return el === permission.id
                                    }
                                  )
                                },
                                {
                                  disabled: !_vm.$_can("carriers.roles.update")
                                }
                              ],
                              attrs: { for: "permissions_id-" + permission.id }
                            },
                            [
                              _c("span", { staticClass: "checkmark" }),
                              _vm._v(
                                _vm._s(permission.description) +
                                  "\n                "
                              ),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.permission_ids,
                                    expression: "permission_ids"
                                  }
                                ],
                                key: index,
                                staticClass: "btn-check",
                                attrs: {
                                  type: "checkbox",
                                  id: "permissions_id-" + permission.id,
                                  disabled: !_vm.$_can("carriers.roles.update")
                                },
                                domProps: {
                                  value: permission.id,
                                  checked: Array.isArray(_vm.permission_ids)
                                    ? _vm._i(
                                        _vm.permission_ids,
                                        permission.id
                                      ) > -1
                                    : _vm.permission_ids
                                },
                                on: {
                                  change: function($event) {
                                    var $$a = _vm.permission_ids,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = permission.id,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.permission_ids = $$a.concat([
                                            $$v
                                          ]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.permission_ids = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.permission_ids = $$c
                                    }
                                  }
                                }
                              })
                            ]
                          )
                        ])
                      ]
                    )
                  })
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.permissionsStep === "claims"
            ? _c("section", [
                _c(
                  "div",
                  { staticClass: "row mb-2 user-role" },
                  _vm._l(_vm.companyPermClaims, function(permission, index) {
                    return _c(
                      "div",
                      { key: permission.id, staticClass: "col-3" },
                      [
                        _c("div", { staticClass: "check-field" }, [
                          _c(
                            "label",
                            {
                              class: [
                                {
                                  "check-open": _vm.permission_ids.find(
                                    function(el) {
                                      return el === permission.id
                                    }
                                  )
                                },
                                {
                                  disabled: !_vm.$_can("carriers.roles.update")
                                }
                              ],
                              attrs: { for: "permissions_id-" + permission.id }
                            },
                            [
                              _c("span", { staticClass: "checkmark" }),
                              _vm._v(
                                _vm._s(permission.description) +
                                  "\n                "
                              ),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.permission_ids,
                                    expression: "permission_ids"
                                  }
                                ],
                                key: index,
                                staticClass: "btn-check",
                                attrs: {
                                  type: "checkbox",
                                  id: "permissions_id-" + permission.id,
                                  disabled: !_vm.$_can("carriers.roles.update")
                                },
                                domProps: {
                                  value: permission.id,
                                  checked: Array.isArray(_vm.permission_ids)
                                    ? _vm._i(
                                        _vm.permission_ids,
                                        permission.id
                                      ) > -1
                                    : _vm.permission_ids
                                },
                                on: {
                                  change: function($event) {
                                    var $$a = _vm.permission_ids,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = permission.id,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.permission_ids = $$a.concat([
                                            $$v
                                          ]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.permission_ids = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.permission_ids = $$c
                                    }
                                  }
                                }
                              })
                            ]
                          )
                        ])
                      ]
                    )
                  })
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.permissionsStep === "users"
            ? _c("section", [
                _c(
                  "div",
                  { staticClass: "row mb-2 user-role" },
                  _vm._l(_vm.companyPermUsers, function(permission, index) {
                    return _c(
                      "div",
                      { key: permission.id, staticClass: "col-3" },
                      [
                        _c("div", { staticClass: "check-field" }, [
                          _c(
                            "label",
                            {
                              class: [
                                {
                                  "check-open": _vm.permission_ids.find(
                                    function(el) {
                                      return el === permission.id
                                    }
                                  )
                                },
                                {
                                  disabled: !_vm.$_can("carriers.roles.update")
                                }
                              ],
                              attrs: { for: "permissions_id-" + permission.id }
                            },
                            [
                              _c("span", { staticClass: "checkmark" }),
                              _vm._v(
                                _vm._s(permission.description) +
                                  "\n                "
                              ),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.permission_ids,
                                    expression: "permission_ids"
                                  }
                                ],
                                key: index,
                                staticClass: "btn-check",
                                attrs: {
                                  type: "checkbox",
                                  id: "permissions_id-" + permission.id,
                                  disabled: !_vm.$_can("carriers.roles.update")
                                },
                                domProps: {
                                  value: permission.id,
                                  checked: Array.isArray(_vm.permission_ids)
                                    ? _vm._i(
                                        _vm.permission_ids,
                                        permission.id
                                      ) > -1
                                    : _vm.permission_ids
                                },
                                on: {
                                  change: function($event) {
                                    var $$a = _vm.permission_ids,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = permission.id,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.permission_ids = $$a.concat([
                                            $$v
                                          ]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.permission_ids = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.permission_ids = $$c
                                    }
                                  }
                                }
                              })
                            ]
                          )
                        ])
                      ]
                    )
                  })
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.permissionsStep === "movers"
            ? _c("section", [
                _c(
                  "div",
                  { staticClass: "row mb-2 user-role" },
                  _vm._l(_vm.companyPermMovers, function(permission, index) {
                    return _c(
                      "div",
                      { key: permission.id, staticClass: "col-3" },
                      [
                        _c("div", { staticClass: "check-field" }, [
                          _c(
                            "label",
                            {
                              class: [
                                {
                                  "check-open": _vm.permission_ids.find(
                                    function(el) {
                                      return el === permission.id
                                    }
                                  )
                                },
                                {
                                  disabled: !_vm.$_can("carriers.roles.update")
                                }
                              ],
                              attrs: { for: "permissions_id-" + permission.id }
                            },
                            [
                              _c("span", { staticClass: "checkmark" }),
                              _vm._v(
                                _vm._s(permission.description) +
                                  "\n                "
                              ),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.permission_ids,
                                    expression: "permission_ids"
                                  }
                                ],
                                key: index,
                                staticClass: "btn-check",
                                attrs: {
                                  type: "checkbox",
                                  id: "permissions_id-" + permission.id,
                                  disabled: !_vm.$_can("carriers.roles.update")
                                },
                                domProps: {
                                  value: permission.id,
                                  checked: Array.isArray(_vm.permission_ids)
                                    ? _vm._i(
                                        _vm.permission_ids,
                                        permission.id
                                      ) > -1
                                    : _vm.permission_ids
                                },
                                on: {
                                  change: function($event) {
                                    var $$a = _vm.permission_ids,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = permission.id,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.permission_ids = $$a.concat([
                                            $$v
                                          ]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.permission_ids = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.permission_ids = $$c
                                    }
                                  }
                                }
                              })
                            ]
                          )
                        ])
                      ]
                    )
                  })
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.permissionsStep === "trucks"
            ? _c("section", [
                _c(
                  "div",
                  { staticClass: "row mb-2 user-role" },
                  _vm._l(_vm.companyPermTrucks, function(permission, index) {
                    return _c(
                      "div",
                      { key: permission.id, staticClass: "col-3" },
                      [
                        _c("div", { staticClass: "check-field" }, [
                          _c(
                            "label",
                            {
                              class: [
                                {
                                  "check-open": _vm.permission_ids.find(
                                    function(el) {
                                      return el === permission.id
                                    }
                                  )
                                },
                                {
                                  disabled: !_vm.$_can("carriers.roles.update")
                                }
                              ],
                              attrs: { for: "permissions_id-" + permission.id }
                            },
                            [
                              _c("span", { staticClass: "checkmark" }),
                              _vm._v(
                                _vm._s(permission.description) +
                                  "\n                "
                              ),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.permission_ids,
                                    expression: "permission_ids"
                                  }
                                ],
                                key: index,
                                staticClass: "btn-check",
                                attrs: {
                                  type: "checkbox",
                                  id: "permissions_id-" + permission.id,
                                  disabled: !_vm.$_can("carriers.roles.update")
                                },
                                domProps: {
                                  value: permission.id,
                                  checked: Array.isArray(_vm.permission_ids)
                                    ? _vm._i(
                                        _vm.permission_ids,
                                        permission.id
                                      ) > -1
                                    : _vm.permission_ids
                                },
                                on: {
                                  change: function($event) {
                                    var $$a = _vm.permission_ids,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = permission.id,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.permission_ids = $$a.concat([
                                            $$v
                                          ]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.permission_ids = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.permission_ids = $$c
                                    }
                                  }
                                }
                              })
                            ]
                          )
                        ])
                      ]
                    )
                  })
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.permissionsStep === "transactions"
            ? _c("section", [
                _c(
                  "div",
                  { staticClass: "row mb-2 user-role" },
                  _vm._l(_vm.companyPermTransactions, function(
                    permission,
                    index
                  ) {
                    return _c(
                      "div",
                      { key: permission.id, staticClass: "col-3" },
                      [
                        _c("div", { staticClass: "check-field" }, [
                          _c(
                            "label",
                            {
                              class: [
                                {
                                  "check-open": _vm.permission_ids.find(
                                    function(el) {
                                      return el === permission.id
                                    }
                                  )
                                },
                                {
                                  disabled: !_vm.$_can("carriers.roles.update")
                                }
                              ],
                              attrs: { for: "permissions_id-" + permission.id }
                            },
                            [
                              _c("span", { staticClass: "checkmark" }),
                              _vm._v(
                                _vm._s(permission.description) +
                                  "\n                "
                              ),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.permission_ids,
                                    expression: "permission_ids"
                                  }
                                ],
                                key: index,
                                staticClass: "btn-check",
                                attrs: {
                                  type: "checkbox",
                                  id: "permissions_id-" + permission.id,
                                  disabled: !_vm.$_can("carriers.roles.update")
                                },
                                domProps: {
                                  value: permission.id,
                                  checked: Array.isArray(_vm.permission_ids)
                                    ? _vm._i(
                                        _vm.permission_ids,
                                        permission.id
                                      ) > -1
                                    : _vm.permission_ids
                                },
                                on: {
                                  change: function($event) {
                                    var $$a = _vm.permission_ids,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = permission.id,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.permission_ids = $$a.concat([
                                            $$v
                                          ]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.permission_ids = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.permission_ids = $$c
                                    }
                                  }
                                }
                              })
                            ]
                          )
                        ])
                      ]
                    )
                  })
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.permissionsStep === "customers"
            ? _c("section", [
                _c(
                  "div",
                  { staticClass: "row mb-2 user-role" },
                  _vm._l(_vm.companyPermCustomers, function(permission, index) {
                    return _c(
                      "div",
                      { key: permission.id, staticClass: "col-3" },
                      [
                        _c("div", { staticClass: "check-field" }, [
                          _c(
                            "label",
                            {
                              class: [
                                {
                                  "check-open": _vm.permission_ids.find(
                                    function(el) {
                                      return el === permission.id
                                    }
                                  )
                                },
                                {
                                  disabled: !_vm.$_can("carriers.roles.update")
                                }
                              ],
                              attrs: { for: "permissions_id-" + permission.id }
                            },
                            [
                              _c("span", { staticClass: "checkmark" }),
                              _vm._v(
                                _vm._s(permission.description) +
                                  "\n                "
                              ),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.permission_ids,
                                    expression: "permission_ids"
                                  }
                                ],
                                key: index,
                                staticClass: "btn-check",
                                attrs: {
                                  type: "checkbox",
                                  id: "permissions_id-" + permission.id,
                                  disabled: !_vm.$_can("carriers.roles.update")
                                },
                                domProps: {
                                  value: permission.id,
                                  checked: Array.isArray(_vm.permission_ids)
                                    ? _vm._i(
                                        _vm.permission_ids,
                                        permission.id
                                      ) > -1
                                    : _vm.permission_ids
                                },
                                on: {
                                  change: function($event) {
                                    var $$a = _vm.permission_ids,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = permission.id,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.permission_ids = $$a.concat([
                                            $$v
                                          ]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.permission_ids = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.permission_ids = $$c
                                    }
                                  }
                                }
                              })
                            ]
                          )
                        ])
                      ]
                    )
                  })
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.permissionsStep === "settings"
            ? _c("section", [
                _c(
                  "div",
                  { staticClass: "row mb-2 user-role" },
                  _vm._l(_vm.companyPermSettings, function(permission, index) {
                    return _c(
                      "div",
                      { key: permission.id, staticClass: "col-3" },
                      [
                        _c("div", { staticClass: "check-field" }, [
                          _c(
                            "label",
                            {
                              class: [
                                {
                                  "check-open": _vm.permission_ids.find(
                                    function(el) {
                                      return el === permission.id
                                    }
                                  )
                                },
                                {
                                  disabled: !_vm.$_can("carriers.roles.update")
                                }
                              ],
                              attrs: { for: "permissions_id-" + permission.id }
                            },
                            [
                              _c("span", { staticClass: "checkmark" }),
                              _vm._v(
                                _vm._s(permission.description) +
                                  "\n                "
                              ),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.permission_ids,
                                    expression: "permission_ids"
                                  }
                                ],
                                key: index,
                                staticClass: "btn-check",
                                attrs: {
                                  type: "checkbox",
                                  id: "permissions_id-" + permission.id,
                                  disabled: !_vm.$_can("carriers.roles.update")
                                },
                                domProps: {
                                  value: permission.id,
                                  checked: Array.isArray(_vm.permission_ids)
                                    ? _vm._i(
                                        _vm.permission_ids,
                                        permission.id
                                      ) > -1
                                    : _vm.permission_ids
                                },
                                on: {
                                  change: function($event) {
                                    var $$a = _vm.permission_ids,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = permission.id,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.permission_ids = $$a.concat([
                                            $$v
                                          ]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.permission_ids = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.permission_ids = $$c
                                    }
                                  }
                                }
                              })
                            ]
                          )
                        ])
                      ]
                    )
                  })
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm._m(2),
          _vm._v(" "),
          _c("section", [
            _c(
              "div",
              { staticClass: "row mb-2 user-role" },
              _vm._l(_vm.notificationTypes, function(type) {
                return _c(
                  "div",
                  {
                    key: type.id,
                    staticClass:
                      "col-5 d-flex justify-content-between align-items-center"
                  },
                  [
                    _c("div", { staticClass: "check-field" }, [
                      _c(
                        "label",
                        {
                          class: {
                            "check-open": _vm.notification_type_ids.find(
                              function(el) {
                                return el.id === type.id
                              }
                            )
                          },
                          attrs: { for: "notification_types_id-" + type.id }
                        },
                        [
                          _c("span", { staticClass: "checkmark" }),
                          _vm._v(_vm._s(type.description)),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.notification_type_ids,
                                expression: "notification_type_ids"
                              }
                            ],
                            key: type.id,
                            staticClass: "btn-check",
                            attrs: {
                              type: "checkbox",
                              id: "notification_types_id-" + type.id
                            },
                            domProps: {
                              value: _vm.notification_type_ids.find(function(
                                el
                              ) {
                                return el.id === type.id
                              })
                                ? _vm.notification_type_ids.find(function(el) {
                                    return el.id === type.id
                                  })
                                : type,
                              checked: Array.isArray(_vm.notification_type_ids)
                                ? _vm._i(
                                    _vm.notification_type_ids,
                                    _vm.notification_type_ids.find(function(
                                      el
                                    ) {
                                      return el.id === type.id
                                    })
                                      ? _vm.notification_type_ids.find(function(
                                          el
                                        ) {
                                          return el.id === type.id
                                        })
                                      : type
                                  ) > -1
                                : _vm.notification_type_ids
                            },
                            on: {
                              change: function($event) {
                                var $$a = _vm.notification_type_ids,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = _vm.notification_type_ids.find(
                                      function(el) {
                                        return el.id === type.id
                                      }
                                    )
                                      ? _vm.notification_type_ids.find(function(
                                          el
                                        ) {
                                          return el.id === type.id
                                        })
                                      : type,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.notification_type_ids = $$a.concat([
                                        $$v
                                      ]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.notification_type_ids = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.notification_type_ids = $$c
                                }
                              }
                            }
                          })
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    !type.disabled_only_own
                      ? _c(
                          "div",
                          { staticClass: "d-flex align-items-center pl-2" },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "pr-2",
                                class: { disabled: _vm.disabledAllLeads }
                              },
                              [
                                _vm._v(
                                  "\n                All leads\n              "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("label", { staticClass: "switch mr-2" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.onlyOwn,
                                    expression: "onlyOwn"
                                  }
                                ],
                                attrs: { type: "checkbox" },
                                domProps: {
                                  value: _vm.notification_type_ids.find(
                                    function(el) {
                                      return el.id === type.id
                                    }
                                  ),
                                  checked: Array.isArray(_vm.onlyOwn)
                                    ? _vm._i(
                                        _vm.onlyOwn,
                                        _vm.notification_type_ids.find(function(
                                          el
                                        ) {
                                          return el.id === type.id
                                        })
                                      ) > -1
                                    : _vm.onlyOwn
                                },
                                on: {
                                  click: function($event) {
                                    _vm.toggleSwitch(
                                      type,
                                      _vm.notification_type_ids.find(function(
                                        el
                                      ) {
                                        return el.id === type.id
                                      })
                                    )
                                  },
                                  change: function($event) {
                                    var $$a = _vm.onlyOwn,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = _vm.notification_type_ids.find(
                                          function(el) {
                                            return el.id === type.id
                                          }
                                        ),
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.onlyOwn = $$a.concat([$$v]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.onlyOwn = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.onlyOwn = $$c
                                    }
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "slider round" })
                            ]),
                            _vm._v(" "),
                            _c(
                              "span",
                              { class: { disabled: _vm.disabledOnlyOwn } },
                              [
                                _vm._v(
                                  "\n                Only own\n              "
                                )
                              ]
                            )
                          ]
                        )
                      : _vm._e()
                  ]
                )
              })
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row mt-3 mb-2" }, [
            _c("div", { staticClass: "col" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-delete float-left",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      _vm.$router.push("/settings/user-roles")
                    }
                  }
                },
                [_vm._v("\n            Cancel\n          ")]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col text-right" }, [
              _vm.$_can("carriers.roles.destroy")
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-delete",
                      attrs: { type: "button" },
                      on: { click: _vm.deleteRole }
                    },
                    [_vm._v("\n            Delete\n          ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.$_can("carriers.roles.update")
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-primary ld-ext-right",
                      class: _vm.loadingButton ? "running" : "",
                      attrs: { type: "submit", disabled: _vm.buttonDisabled }
                    },
                    [
                      _vm._v("\n            Save\n            "),
                      _c("div", { staticClass: "ld ld-ball ld-flip" })
                    ]
                  )
                : _vm._e()
            ])
          ])
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row pt-3 l-m-b-20" }, [
      _c("div", { staticClass: "col-12" }, [_c("h1", [_vm._v("Edit Role")])])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col" }, [
        _c("h2", { staticClass: "l-header-2" }, [_vm._v("Permissions")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row mt-4" }, [
      _c("div", { staticClass: "col" }, [
        _c("h2", { staticClass: "l-header-2" }, [_vm._v("Notification types")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-23b4ee80", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23b4ee80","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/UserRoles/SettingsUserRolesEdit.vue
// module id = null
// module chunks = 